// extracted by mini-css-extract-plugin
export default {"list":"burger-ingredients-sets_list__D8VDu","scroll":"burger-ingredients-sets_scroll__2PqOF"};